import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { createCompany } from "./api";
import { invalidateAllCompaniesQueries } from "../query";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  return {
    ...Object.fromEntries(
      Object.entries(values).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export function useCreateCompany() {
  return useMutation({
    mutationFn: async ({ item }) => {
      const payload = buildPayload(item);
      const response = await createCompany({ item: payload });
      return response;
    },
    onSuccess: () => {
      toast.success("Company Created Successfully");
      invalidateAllCompaniesQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      invalidateAllCompaniesQueries();
    },
  });
}
